export enum Endpoints {
    SEND_INVITE = '/api-db/resources/v2/dashboard/invite/send',
    ACCEPT_INVITE = '/api-db/resources/v2/dashboard/invite/acceptInvite?inviteeId=',
    CANCEL_INVITE = '/api-db/resources/v2/dashboard/invite/cancelInvite/',
    COPY_INVITE = '/accept-invite?inviteeId=',
}
